import { Outlet, useOutletContext, useParams } from 'react-router-dom'

export default function ApplicationAbTestsLayoutPage() {
  const { application } = useOutletContext()
  const { id: applicationId } = useParams()

  return <Outlet context={{ application, applicationId }} />
}

